import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import WeekCalendar from "./WeekCalendar";
// import WeeklyHoursModal from "./WeeklyHoursModal";

const SlotLayout = () => {
  return (
    <MasterLayout>
      {/* <Breadcrumb title="Slots" /> */}
      {/* <WeeklyHoursModal /> */}
      <div className="col-xxl-12 col-lg-12">
        <div className="card h-100 p-0">
          <div className="card-body p-24">
            <div id="wrap">
              <div id="calendar" />
              <div style={{ clear: "both" }} />
              <WeekCalendar />
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default SlotLayout;
